import { Utils } from '@pacem/pacem-core';
import { Colors } from '@pacem/pacem-foundation';
import { isBasicMaterial, isLineMaterial, KnownShader } from '../../materials/material';
import { Buffers } from './buffers';
import { GPUTextureUsage } from './constants';
import { getBasicMaterialFragmentWgsl } from './wgsl/basic-material-fragment';
import { getLineMaterialFragmentWgsl } from './wgsl/line-material-fragment';
import { LABEL_PREFIX } from './constants';
//namespace Pacem.Drawing3D.WebGPU {
export class Materials {
    static create(material) {
        if (isBasicMaterial(material)) {
            return new BasicMaterial(material);
        }
        if (isLineMaterial(material)) {
            return new LineMaterial(material);
        }
        throw new TypeError(`Material type '${material.shader}' not supported.`);
    }
}
const EmptyMaterialWGSLDelegates = {
// empty delegates
};
class MaterialBase {
    constructor(material) {
        if (Utils.isNull(this.#material = material)) {
            throw new ReferenceError("Null material provided.");
        }
    }
    #material;
    get material() { return this.#material; }
    get wgsl() {
        return EmptyMaterialWGSLDelegates;
    }
    buffer({ device }, label = LABEL_PREFIX + 'material-' + this.shader + '-buffer') {
        const { r, g, b, a } = this._diffuseColor();
        const materialValue = new Float32Array([r, g, b, a]);
        return { buffer: Buffers.createStorage(device, materialValue, label), value: materialValue, version: performance.now() };
    }
    _diffuseColor() {
        const { visible, opacity, color } = this.material;
        if (!(visible ?? true)) {
            return { r: 0, g: 0, b: 0, a: 0 };
        }
        const retval = typeof color === 'string' ? Colors.parse(color) : (color ?? { r: 1, g: 1, b: 1, a: 1 });
        if (opacity >= 0 && opacity <= 1) {
            return Utils.extend(retval, { a: retval.a * opacity });
        }
        return retval;
    }
}
export class BasicMaterial extends MaterialBase {
    get shader() {
        return KnownShader.Basic;
    }
    constructor(material) {
        super(material);
        if (material.shader != this.shader) {
            throw new TypeError("Basic material expected.");
        }
    }
    texture({ device }, key = 'texture') {
        const material = this.material;
        if (key === 'texture' && !Utils.isNull(material.texture)) {
            const texBmp = material.texture;
            const texture = device.createTexture({
                format: 'rgba8unorm',
                usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_DST,
                size: [texBmp.width, texBmp.height],
            });
            return { texture, source: texBmp };
        }
        return null;
    }
    // TODO: put it in the material instance/interface
    static { this.fragment = getBasicMaterialFragmentWgsl; }
}
export class LineMaterial extends MaterialBase {
    get shader() {
        return KnownShader.Line;
    }
    constructor(material) {
        super(material);
        if (material.shader != this.shader) {
            throw new TypeError("Line material expected.");
        }
    }
    buffer(ctx, key) {
        switch (key) {
            case 'line':
                const { device, canvas } = ctx;
                const lineMaterial = this.material;
                const lineValue = new Float32Array([canvas.clientWidth, canvas.clientHeight, lineMaterial.lineWidth / 2]);
                return { buffer: Buffers.createUniform(device, lineValue, LABEL_PREFIX + 'line-' + this.shader + '-buffer'), value: lineValue, version: performance.now() };
            default:
                return super.buffer(ctx);
        }
    }
    texture(_) {
        return null;
    }
    static { this.fragment = getLineMaterialFragmentWgsl; }
}
